import { render, staticRenderFns } from "./test-line.vue?vue&type=template&id=37196f2a&scoped=true"
import script from "./test-line.vue?vue&type=script&lang=js"
export * from "./test-line.vue?vue&type=script&lang=js"
import style0 from "./test-line.vue?vue&type=style&index=0&id=37196f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37196f2a",
  null
  
)

export default component.exports